// IE11 is a bit broken if we import the module as usual so lets import the
// compiled js directly to fix it...
import Swiper from '../../../node_modules/swiper/js/swiper';

export default class SwiperJS {
    constructor() {
        const swipperWrappers = document.querySelectorAll('.js-swiper');

        if (swipperWrappers) {
            SwiperJS.init(swipperWrappers);
        }
    }

    static init(node) {
        node.forEach((swipperWrapper) => {
            // eslint-disable-next-line no-unused-vars
            const item = new Swiper(
                swipperWrapper,
                {
                    autoplay: swipperWrapper.dataset.autoplay
                        ? { delay: swipperWrapper.dataset.autoplay }
                        : false,
                    slidesPerView: swipperWrapper.dataset.slidesPerView || 1,
                    slidesPerColumnFill: swipperWrapper.dataset.slidesPerColumnFill ? swipperWrapper.dataset.slidesPerColumnFill : 'column',
                    speed: 800,
                    autoHeight: swipperWrapper.dataset.autoHeight ? (swipperWrapper.dataset.autoHeight === 'true') : true,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                },
            );
        });
    }
}
